
import { HashRouter as Router, Route, Routes, Switch } from 'react-router-dom';

import './App.css';
import Conocenos from './components/Conocenos';
import Contacto from './components/Contacto';
import FAQ from './components/FAQ.jsx';
import FAQdetail from './components/FAQdetail';
import Home from './components/Home';
import Navbar from './components/Navbar';
import ReservationEngine from './components/ReservationEngine';
import Pagos from './components/Pagos';
import Reservas from './components/Reservas.jsx';
function App() {
  return (
    <div className="App">
       <Routes>
 
     <Route  path={"/"} element={<Home/>}/>
    <Route path={"/preguntas-frecuentes"} element={<FAQ/>}/>
    <Route  path={"/preguntas-frecuentes/:id"} element={<FAQdetail/>}/>
    <Route  path={"/conocenos"} element={<Conocenos/>}/>
    <Route  path={"/contacto"} element={<Contacto/>}/>
    <Route  path={"/pagos"} element={<Pagos/>}/>
    <Route  path={"/reservas"} element={<Reservas/>}/>
   
    </Routes>
    </div>
  );
}


export default App;
